import { Typography } from "@material-ui/core"
import { Code, CodeBlock, CopyBlock, dracula } from "react-code-blocks"

export const ConsultaUnidade = () => {

    const text = `GET /v1/consulta-unidades
Host: api.app.juristta.com
Authorization: Bearer v1_a2f5i10a_abc123def456ghi789jk`

    const text2 = `[
    {
        "id": "123abc45-6def-789g-hi01-2jkl345mno67",
        "name": "Matriz",
        "active": true
    },
    {
        "id": "483426d8-99c6-8dbb-4243-e1b3810c6a8d",
        "name": "Unidade 1",
        "active": true
    },
    {
        "id": "abc123de-eed6-4243-8dab-45mn810c644d",
        "name": "Unidade 2",
        "active": true
    }
]
`

    return <>
        <Typography variant="h6">Consulta de períodos letivos</Typography>
        <div style={{ marginBottom: '16px' }} />

        <Typography variant='body1'>Este endpoint permite consultar o id de todas as unidades cadastradas para esta instituição. Toda instituição tem por padrão uma unidade cadastrada com o nome de Matriz. O id da unidade é necessário para a utilização de diersos endpoints a fim de ditar para qual unidade as operações terão efeito.</Typography>

        <div style={{ marginBlock: '16px', borderRadius: '8px', backgroundColor: '#1f1f1f', padding: '8px' }}>
            <div>
                <Typography variant="body1" component='span' style={{ fontWeight: 'bold' }}>Método:</Typography> <Typography component='span'>GET</Typography>
            </div>
            <div>
                <Typography variant="body1" component='span' style={{ fontWeight: 'bold' }}>URL:</Typography> <Typography component='span'>https://api.app.juristta.com/v1/consulta-unidades </Typography>
            </div>
        </div>
        <Typography variant="h6">Exemplo de Requisição </Typography>
        <Typography variant="body1" style={{ fontFamily: 'monospace', marginBlock: '16px' }}>
            <CopyBlock codeBlockStyle={{ fontFamily: 'Arial' }} text={text} language="http" theme={dracula} codeBlock showLineNumbers />
        </Typography>


        <Typography variant="h6">Exemplo de Resposta </Typography>
        <Typography variant="body1" style={{ fontFamily: 'monospace', marginBlock: '16px' }}>
            <CodeBlock codeBlockStyle={{ fontFamily: 'Arial' }} text={text2} language="json" theme={dracula} />
        </Typography>

        <Typography variant="body1">Requisições que não seguirem corretamente a especificação receberão uma resposta com o status <Code language='http' text="HTTP 400 Bad Request." theme={dracula} ></Code> com detalhes do problema. </Typography>

    </>
}